module.exports = __webpack_public_path__ + "spine/dog.json?b84195a10e25ee8d97dcf44cfc3af98b";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spine/dog/dog.json
// module id = 1740
// module chunks = 3